import { createTranslations } from '../i18n/types';

export default createTranslations({
  en: {
    anonymous: 'Anonymous',
  },
  ru: {
    anonymous: 'Аноним',
  },
  uz: {
    anonymous: 'Anonim',
  },
  fa: {
    anonymous: 'ناشناس',
  },
  pt: {
    anonymous: 'Anônimo',
  },
  tr: {
    anonymous: 'Anonim',
  },
  uk: {
    anonymous: 'Анонім',
  },
  de: {
    anonymous: 'Anonym',
  },
  es: {
    anonymous: 'Anónimo',
  },
  pl: {
    anonymous: 'Anonim',
  },
});
